module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ruth Clemens\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_c('B', [_vm._v("Ruth Clemens")]), _vm._v(" is a baker, cake decorator and very busy wife and mother. Completely self taught, Ruth's passion for baking and sugarcrafting shone through when she was a contestant on "), _c('I', [_vm._v("The Great British Bake Off")]), _vm._v(". The Pink Whisk blog was born and the rest, as they say, is history! She is also the author of "), _c('I', [_vm._v("The Pink Whisk Guide to Cake Making")]), _vm._v(" and "), _c('I', [_vm._v("Busy Girl's Guide to Cake Decorating")]), _vm._v(".")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/14uM7DX/tc-custom/9781446361016.jpg?1728726136851",
      "alt": "This image is the cover for the book Pink Whisk Guide to Bread Making, The Pink Whisk Guide"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Pink Whisk Guide to Bread Making, The Pink Whisk Guide\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("The Great British Bake Off")])]), _c('b', [_vm._v(" finalist shares delicious bread recipes that rise to every occasion—loaves of all shapes to suit all tastes.")])]), _c('p', [_c('b'), _vm._v("Ruth Clemens, finalist on "), _c('i', [_vm._v("The Great British Bake Off")]), _vm._v(", shares her delicious bread recipes, fitting for all occasions. ")]), _c('p', [_vm._v(" Each of the thirty recipes shows you how to get confident with straightforward doughs, to progress to pre-ferments and experiment with further methods. ")]), _c('p', [_vm._v(" Along with clear step-by-step instructions, the recipes are crammed with tips and tricks to ensure that you’ll be turning out delicious homemade loaves in next to no time. ")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    David & Charles\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0